/* =============================================================================
 * [OS-LEGADO-CONGELADO] ARQUIVO TEMPORARIO - APAGAR APOS VALIDACAO
 * =============================================================================
 * Copia CONGELADA do modulo antigo de "OS para coleta" (versao que estava em
 * producao antes da entrada do modulo novo).
 *
 * Origem desta copia: src/services/LabAnalises/index.ts
 * Papel: camada de API (endpoints congelados)
 *
 * POR QUE ISSO EXISTE
 *   O modulo novo de OS substituiu o antigo. Esta copia fica disponivel por
 *   ~1 SEMANA como plano de contingencia: se o modulo novo apresentar
 *   problema, o time volta a usar esta versao sem interromper o trabalho.
 *
 * NAO EDITE ESTE ARQUIVO
 *   Ele e um retrato fiel do comportamento antigo. Qualquer correcao deve ser
 *   feita no modulo NOVO. Editar aqui destroi o valor da copia.
 *
 * COMO APAGAR (quando o modulo novo for validado)
 *   1. Remover a pasta inteira: src/Views/app/precisao/OSAntigaLegado/
 *   2. Remover a rota/menu marcado com [OS-LEGADO-CONGELADO] em
 *      src/Configs/Navegacao.ts
 *   3. Conferir que nao sobrou nenhuma referencia:
 *        grep -rn "OSAntigaLegado\|OS-LEGADO-CONGELADO" src/
 *   Nada fora desta pasta depende dela, entao a remocao e segura.
 * ========================================================================== */


import { AxiosResponse } from 'axios'
import { api } from '../../../../../../../services/api'

import { localConfig } from '../../Configs/localConfig'
import dayjs from 'dayjs'

export interface TypeGetlaboratorio {
  itens: [LabAnaliseItens]
}

export interface LabAnaliseItens {
  cod_laboratorio?: number
  cod_analise?: number
  cod_categoria_fornecedor?: number
  laboratorio_nome?: string
  analise_nome?: string
  profundidade_nome?: string
  cod_profundidade?: number
  data?: string
  valor?: string
  analises?: {
    profundidade?: {
      nome?: string
      cod?: number
    }
    analises?: [
      {
        cod?: number
        nome?: string
      },
      {
        cod?: number
        nome?: string
      }
    ]
  }
}

export const getLabAnalise = async (cod, codLaboratorio: number, data_vigencia?: string) => {
  const config = localConfig()

  const dataDia = new Date()
  const dia = dataDia.getDate()
  const mes = dataDia.getMonth() + 1
  const ano = dataDia.getFullYear()

  const dataHoje = `${ano}-${mes}-${dia}`;

  let data_consulta = data_vigencia ? dayjs(data_vigencia).format('YYYY-MM-DD') : dataHoje;

  api.defaults.headers.Acesso = config.acesso

  const response: AxiosResponse<TypeGetlaboratorio> = await api.get(
    `/laboratorio-analise/analises?codConta=${config.conta}&codLaboratorio=${codLaboratorio}&cod=${cod}&dataVigente=${data_consulta}&pagination=-1`
  )

  return response
}
